import React from 'react'

function TrackedText ({ children, title, boldTitle }) {
  return (
    <div className='text-gray-500 text-sm'>
      <span className={boldTitle ? 'font-medium' : null}>{title}</span>
      <span className='mx-1'> - </span>
      <span className=''>{children}</span>
    </div>
  )
}

TrackedText.defaultProps = {
  isPlaying: false
}

export default TrackedText
